(() => {
  const C = window.KIT_CATALOG;
  const $ = s => document.querySelector(s);
  const money = n => '$' + (Math.round(n * 100) / 100).toFixed(n % 1 ? 2 : 0);
  const FREE_SHIP = 120;
  const SHOP = 'https://rarely.co';

  const IMG = k => window.DFTD_IMG[k];
  const ROLE = {
    vancortlandt: 'Top', harrier: 'Top', base: 'Next to skin', shorts: 'Legs', halftights: 'Legs',
    tights: 'Legs', hat: 'Head', beanie: 'Head', gloves: 'Hands', socks: 'Feet'
  };
  const SHORT = {
    vancortlandt: 'Van Cortlandt Long Sleeve', harrier: 'Harrier Long Sleeve', base: 'Brighton Base Layer',
    shorts: 'Session Shorts', halftights: 'Twilight Half Tights', tights: 'Turnover Tights',
    hat: 'Session Hat', beanie: 'Prospect Beanie', gloves: 'Inverno Running Gloves', socks: 'Merino Tube Socks'
  };

  const BANDS = [
    { min: 55, name: 'Borrowed summer', verdict: t => `It’ll feel like ${t + 20}° a mile in. Light mesh, short shorts, and keep the sun off your face.`,
      kit: [['vancortlandt', 'Light mesh that dries fast. Sleeves you can push up.'], ['shorts', '5" inseam, Italian liner, three drop-in pockets.'], ['hat', 'Nylon and mesh. Sweatband built in.'], ['socks', 'Merino regulates warm feet, too.']] },
    { min: 45, name: 'Sweater weather, minus the sweater', verdict: t => `Dress like it’s ${t + 20}°. One merino layer does the whole job.`,
      kit: [['harrier', 'Merino blend with 37.5® — warm now, not soggy later.'], ['halftights', '8" inseam, light compression, zip phone pocket.'], ['hat', 'Keeps the early glare and drizzle off.'], ['socks', '56% merino. Warm when wet.']] },
    { min: 35, name: 'Proper cold', verdict: t => `Dress like it’s ${t + 20}°. Legs covered, hands covered, and you’ll forget about the cold by the first turn.`,
      kit: [['harrier', 'Thumbholes for the first ten minutes.'], ['tights', 'Brushed-back Italian Inverno Blend.'], ['gloves', 'Touchpads, and a soft thumb for your nose.'], ['socks', 'Mid-pile terry heel and forefoot.']] },
    { min: 25, name: 'Frost on the windshield', verdict: t => `Dress like it’s ${t + 20}°. Two layers of wool up top, and cover every edge.`,
      kit: [['base', 'Seamless merino mesh right against the skin.'], ['harrier', 'The warm middle. Raglan, no shoulder seams.'], ['tights', 'Full length, zip pocket where your hand lands.'], ['gloves', 'Brushed inside, sheds light rain outside.'], ['beanie', '100% lambswool. Fold once or twice to taste.'], ['socks', 'Cold starts at the feet. Wool stops it.']] },
    { min: -99, name: 'The ones you tell people about', verdict: t => `Dress like it’s ${t + 20}° — and then add one more layer. Short and steady today.`,
      kit: [['base', 'Seamless merino mesh right against the skin.'], ['harrier', 'The warm middle. Raglan, no shoulder seams.'], ['tights', 'Full length, brushed back.'], ['gloves', 'Brushed inside, sheds light rain outside.'], ['beanie', 'Pull it all the way down over the ears.'], ['socks', 'Wool, always.']], note: 'Add the wind shell you already own. Below 25°, wind decides everything.' }
  ];

  const state = { temp: 38, rain: false, size: 'M', off: new Set(), pick: {} };

  const bandFor = t => BANDS.find(b => t >= b.min);

  function variantFor(key) {
    const p = C[key];
    const avail = p.variants.filter(v => v.avail);
    if (!avail.length) return null;
    if (state.pick[key]) {
      const v = p.variants.find(v => v.id === state.pick[key] && v.avail);
      if (v) return v;
    }
    if (avail.length === 1 && p.variants.length === 1) return avail[0];
    const pref = { S: ['S', 'S/M'], M: ['M', 'S/M'], L: ['L', 'L/XL'], XL: ['XL', 'L/XL'] }[state.size] || [];
    return avail.find(v => pref.includes(v.size)) || null;
  }

  function currentKit() {
    const band = bandFor(state.temp);
    let kit = band.kit.slice();
    if (state.rain && state.temp >= 32 && !kit.some(([k]) => k === 'hat')) {
      kit = kit.filter(([k]) => k !== 'beanie');
      kit.splice(kit.length - 1, 0, ['hat', 'A brim keeps rain out of your eyes.']);
    }
    return { band, kit: kit.filter(([k]) => C[k] && C[k].variants.some(v => v.avail)) };
  }

  function cartLines() {
    const { kit } = currentKit();
    const lines = []; let total = 0; let missing = [];
    kit.forEach(([k]) => {
      if (state.off.has(k)) return;
      const v = variantFor(k);
      if (!v) { missing.push(SHORT[k]); return; }
      lines.push(`${v.id}:1`); total += v.price;
    });
    return { lines, total, missing };
  }

  function renderBench(animate) {
    const { band, kit } = currentKit();
    $('#band').textContent = band.name;
    $('#verdict').textContent = band.verdict(state.temp);
    const ol = $('#items');
    ol.innerHTML = '';

    // size strip
    const sz = document.createElement('li');
    sz.className = 'item item--note';
    sz.style.animation = 'none';
    sz.innerHTML = `<div class="item__img">Your<br>size</div><div><span class="item__role">Sizes on the bench</span><div class="sizes" style="justify-content:flex-start;margin-top:8px">${['S', 'M', 'L', 'XL'].map(s => `<button class="size" data-global="${s}" aria-pressed="${state.size === s}">${s}</button>`).join('')}</div></div>`;
    ol.appendChild(sz);

    kit.forEach(([k, why], i) => {
      const p = C[k];
      const v = variantFor(k);
      const li = document.createElement('li');
      li.className = 'item' + (state.off.has(k) ? ' is-off' : '');
      if (animate) li.style.animationDelay = (i * 70) + 'ms'; else li.style.animation = 'none';
      const single = p.variants.length === 1;
      const sizes = single ? `<span class="item__why" style="font-size:12px">${p.variants[0].size}</span>` :
        `<div class="sizes">${p.variants.map(x => `<button class="size" data-k="${k}" data-v="${x.id}" ${x.avail ? '' : 'disabled'} aria-pressed="${v && v.id === x.id}" title="${x.avail ? (x.qty <= 1 ? 'Last one' : 'In stock') : 'Sold out'}">${x.size}</button>`).join('')}</div>`;
      const price = p.variants.find(x => x.avail).price;
      const lowNote = v && v.qty === 1 ? ' · last one in this size' : (!v ? ' · your size is out — pick another' : '');
      li.innerHTML = `
        <a class="item__img" href="${p.url}" target="_blank" rel="noopener"><img src="${IMG(k)}" alt="${SHORT[k]}"></a>
        <div>
          <span class="item__role">${ROLE[k]}${lowNote}</span>
          <a class="item__name" href="${p.url}" target="_blank" rel="noopener">${SHORT[k]}</a>
          <p class="item__why">${why}</p>
        </div>
        <div class="item__right">
          <span class="item__price">${money(price)}</span>
          ${sizes}
          <button class="item__skip" data-skip="${k}">${state.off.has(k) ? 'Add back' : 'I have this'}</button>
        </div>`;
      ol.appendChild(li);
    });

    if (band.note) {
      const li = document.createElement('li');
      li.className = 'item item--note';
      li.innerHTML = `<div class="item__img">Your<br>shell</div><div><span class="item__role">Outer layer</span><p class="item__why" style="margin-top:4px">${band.note}</p></div>`;
      ol.appendChild(li);
    }
    renderTotals();
  }

  function renderTotals() {
    const { lines, total, missing } = cartLines();
    const { kit } = currentKit();
    const pct = Math.min(100, total / FREE_SHIP * 100);
    $('#shipFill').style.width = pct + '%';
    $('#shipMsg').textContent = !lines.length ? 'Choose at least one piece.' :
      total >= FREE_SHIP ? 'This kit ships free in the U.S.' :
      `Add ${money(FREE_SHIP - total)} more for free U.S. shipping — socks are $20.`;
    $('#total').textContent = money(total);
    $('#total2').textContent = money(total);
    $('#stickyTotal').textContent = money(total);
    const t = state.temp + '°';
    $('#finalTemp').textContent = t; $('#stickyTemp').textContent = t;
    const names = kit.filter(([k]) => !state.off.has(k)).map(([k]) => SHORT[k]);
    $('#finalList').textContent = names.join(', ') + '.';
    const href = lines.length ? `${SHOP}/cart/${lines.join(',')}?ref=dress-for-the-degree` : '#';
    ['#buyKit', '#buyKit2', '#buyKit3'].forEach(s => {
      const a = $(s); a.href = href;
      a.setAttribute('aria-disabled', lines.length ? 'false' : 'true');
      a.dataset.value = total.toFixed(2);
    });
    $('#buyKit').textContent = missing.length ? `Pick a size for ${missing.length === 1 ? missing[0] : missing.length + ' pieces'}` : 'Put this kit in my bag';
    if (missing.length) $('#buyKit').setAttribute('aria-disabled', 'true');
  }

  function setTemp(t, fromUser) {
    const prev = bandFor(state.temp);
    state.temp = Math.max(10, Math.min(65, Math.round(t)));
    $('#temp').value = state.temp;
    $('#tempNum').textContent = state.temp;
    const pct = (65 - state.temp) / 55 * 100;
    $('#mercury').style.width = (100 - pct) + '%';
    document.querySelector('.therm__track').style.setProperty('--knob', pct + '%');
    const hue = state.temp < 30 ? '#CFE0EA' : state.temp > 55 ? '#F6C9A8' : '#FFFFF3';
    $('#tempNum').style.color = hue;
    const changed = prev !== bandFor(state.temp);
    if (changed) state.off.clear();
    renderBench(changed || !fromUser);
  }

  // events
  $('#temp').addEventListener('input', e => setTemp(+e.target.value, true));
  $('#rain').addEventListener('change', e => { state.rain = e.target.checked; renderBench(true); });
  $('#items').addEventListener('click', e => {
    const g = e.target.closest('[data-global]');
    if (g) { state.size = g.dataset.global; state.pick = {}; renderBench(false); return; }
    const s = e.target.closest('.size[data-v]');
    if (s) { state.pick[s.dataset.k] = +s.dataset.v; renderBench(false); return; }
    const k = e.target.closest('[data-skip]');
    if (k) { const key = k.dataset.skip; state.off.has(key) ? state.off.delete(key) : state.off.add(key); renderBench(false); }
  });
  document.querySelectorAll('.row[data-t]').forEach(r => r.addEventListener('click', () => {
    setTemp(+r.dataset.t); document.getElementById('dial').scrollIntoView({ behavior: 'smooth' });
  }));

  $('#geo').addEventListener('click', () => {
    const btn = $('#geo'); const label = btn.lastChild;
    if (!navigator.geolocation) { $('#where').textContent = 'Location isn’t available — drag the mercury instead'; return; }
    label.textContent = ' Checking the sky…';
    navigator.geolocation.getCurrentPosition(async pos => {
      try {
        const { latitude: la, longitude: lo } = pos.coords;
        const r = await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${la}&longitude=${lo}&current=apparent_temperature,precipitation,weather_code&hourly=apparent_temperature&temperature_unit=fahrenheit&forecast_days=2&timezone=auto`);
        const d = await r.json();
        // Tomorrow at 6 a.m. local — when people actually run
        const idx = d.hourly.time.findIndex((t, i) => i > 12 && t.endsWith('T06:00'));
        const dawn = idx > -1 ? d.hourly.apparent_temperature[idx] : d.current.apparent_temperature;
        const wet = (d.current.precipitation || 0) > 0 || [51,53,55,61,63,65,71,73,75,80,81,82,85,86].includes(d.current.weather_code);
        state.rain = wet; $('#rain').checked = wet;
        $('#where').textContent = `Tomorrow, 6 a.m. near you · feels like ${Math.round(dawn)}°F`;
        setTemp(dawn);
        label.textContent = ' Updated with your weather';
      } catch (err) { label.textContent = ' Weather unavailable — drag instead'; }
    }, () => { label.textContent = ' No problem — drag the mercury'; }, { timeout: 9000, maximumAge: 600000 });
  });

  // pixel + checkout
  ['#buyKit', '#buyKit2', '#buyKit3'].forEach(s => $(s).addEventListener('click', e => {
    const a = e.currentTarget;
    if (a.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
    try { window.fbq && fbq('track', 'InitiateCheckout', { value: +a.dataset.value, currency: 'USD', content_category: 'Tracksmith cold-weather kit', content_ids: cartLines().lines.map(l => l.split(':')[0]), content_type: 'product' }); } catch (_) {}
  }));

  // shop grid
  const order = ['harrier', 'base', 'tights', 'halftights', 'gloves', 'beanie', 'socks', 'vancortlandt', 'shorts', 'hat'];
  $('#shopGrid').innerHTML = order.map(k => {
    const p = C[k]; const av = p.variants.filter(v => v.avail);
    const sizes = p.variants.length > 1 ? av.map(v => v.size).join(' · ') : p.variants[0].size;
    const low = av.reduce((n, v) => n + v.qty, 0) <= 3 ? '<span class="card__stock">Only a few left</span>' : '';
    return `<a class="card" href="${p.url}" target="_blank" rel="noopener"><div class="card__img"><img src="${IMG(k)}" alt="${SHORT[k]}" loading="lazy"></div><div class="card__body"><span class="card__name">${SHORT[k]}</span><span class="card__meta">${sizes}</span>${low}<span class="card__price">${money(av[0].price)}</span></div></a>`;
  }).join('');

  // live inventory refresh (works on rarely.co; silently keeps baked data elsewhere)
  async function refresh() {
    await Promise.all(Object.entries(C).map(async ([k, p]) => {
      try {
        const r = await fetch(`/products/${encodeURIComponent(p.handle)}.js`, { credentials: 'same-origin' });
        if (!r.ok) return;
        const d = await r.json();
        d.variants.forEach(v => {
          const m = p.variants.find(x => x.id === v.id);
          if (m) { m.avail = v.available; m.price = v.price / 100; }
        });
      } catch (_) {}
    }));
    renderBench(false);
  }

  // chrome
  const bar = document.querySelector('.bar'); const sticky = $('#sticky');
  const dialEl = $('#dial'); const finalEl = document.querySelector('.final');
  const bleedImg = document.querySelector('.bleed img');
  let dialSeen = false, finalIn = false;
  new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) dialSeen = true; }), { threshold: .2 }).observe(dialEl);
  new IntersectionObserver(es => es.forEach(e => { finalIn = e.isIntersecting; }), { threshold: .15 }).observe(finalEl);
  const onScroll = () => {
    const y = scrollY;
    bar.classList.toggle('is-solid', y > 40);
    const dialRect = dialEl.getBoundingClientRect();
    const inDial = dialRect.top < innerHeight * .5 && dialRect.bottom > innerHeight * .5;
    sticky.classList.toggle('is-on', dialSeen && !inDial && !finalIn && y > innerHeight);
    const r = bleedImg.parentElement.getBoundingClientRect();
    if (r.bottom > 0 && r.top < innerHeight) bleedImg.style.transform = `translateY(${(r.top / innerHeight) * -12 - 8}%)`;
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  const STATIC = /[?&]static\b/.test(location.search);
  const rev = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); rev.unobserve(e.target); } }), { threshold: .12 });
  document.querySelectorAll('.rule, .almanac__head, .almanac__table, .spread > *, .layer, .shop__head, .card, .why > *, .faq details').forEach(el => { if (STATIC) return; el.classList.add('reveal'); rev.observe(el); });

  // hero clock: a real dawn countdown feel — shows the next 5:xx a.m. minute ticking

  setTemp(38);
  refresh();
})();
